
import { IADPState} from "../state";
import {DeviceMetrics, DeviceReadinessInfo, StressTest, assessmentLocation} from "../types"
import RequestService from "../util/request";
import { environment } from "../util";
export function DeviceMetricsService() {
   const postDeviceMetrics=async (state: IADPState, deviceReadinessInfo: DeviceReadinessInfo,stressTestInfo?:StressTest,location?:assessmentLocation )=>{
     const onlineServiceConfig = state.appState.configuration?.onlineServices;
     const ncsServiceConfig = state.connectedNCSState?.config.adsServices;
     let url = `${environment.resolveApiDomain()}/${onlineServiceConfig?.postDeviceMetrics}`;
     if(ncsServiceConfig && state.sessionState.selectedAssessmentMode === "ncs"){
       url = ncsServiceConfig?.deviceMetricsUrl
     };
      //@ts-ignore
    const batteryLevel = await navigator.getBattery();
    if(!state.sessionState.schoolDetails?.setupCode) return;
    const payload:DeviceMetrics={
            "data": {
                "adpLaunchId": state.appState.appLaunchId as string,
                "deviceModel": state.deviceState.deviceModel || "chromebook",
                "setupCode": state.sessionState.schoolDetails.setupCode?.toUpperCase(),
                "assessmentDeliveryMode":state.sessionState.selectedAssessmentMode,
                "readinessCheckInfo": deviceReadinessInfo ? deviceReadinessInfo : state.deviceReadinessState.deviceReadinessInfo,
                "statusInfo": {
                    "currentBatteryCharge": batteryLevel?.level?.toString() || "0",
                    "lastUpdatedAt": new Date().toISOString()
                }  
            },
            "clientDetails": {
                "ip": state.sessionState.networkDetails?.address || "127.0.0.1",
                "appName": "ADP",
                "deviceDetails": {
                    "deviceType": state.deviceState.deviceType || "SBE",
                    "deviceName":state.deviceState.deviceId as string,
                    "deviceId": state.deviceState.deviceId as string
                }
            }
        }
     if(state.networkReadinessState.executionState){
         payload.data.stressTestInfo = stressTestInfo ? stressTestInfo : state.networkReadinessState.executionState  
     }
     if(location){
        payload.data.assessmentLocation = location;
     }
     const isDeviceMetricsPosted = await RequestService.postDeviceMetrics(payload,`${url}/${state.appState.appLaunchId}` as string,false);
     return  isDeviceMetricsPosted
   }
   const patchDeviceMetrics=(state: IADPState)=>{
    const url = state.sessionState.selectedAssessmentMode === "ncs"
     ? state.connectedNCSState?.config.adsServices.deviceMetricsUrl 
     :  `${environment.resolveApiDomain()}/${state.appState.configuration?.onlineServices.postDeviceMetrics}`;
     console.log("patch", url)
    if(!state.sessionState.schoolDetails?.setupCode) return;
    const payload:DeviceMetrics={
            "data": {
                "adpLaunchId": state.appState.appLaunchId as string,
                "deviceModel": "chromebook",
                "setupCode": state.sessionState.schoolDetails.setupCode?.toUpperCase(),
                "assessmentDeliveryMode":state.sessionState.selectedAssessmentMode,
                "statusInfo": {
                    "currentBatteryCharge": state.deviceState.battery?.level.toLocaleString() || "0",
                    "lastUpdatedAt": new Date().toISOString()
                }  
            },
            "clientDetails": {
                "ip": state.sessionState.networkDetails?.address || "127.0.0.1",
                "appName": "ADP",
                "deviceDetails": {
                    "deviceType": state.deviceState.deviceType || "SBE",
                    "deviceName":state.deviceState.deviceId as string,
                    "deviceId": state.deviceState.deviceId as string
                }
            }
        }
        RequestService.postDeviceMetrics(payload,`${url}/${state.appState.appLaunchId}` as string,true);
   }
  
   return {postDeviceMetrics,patchDeviceMetrics}
}



